<template lang="pug">
.filters-group.ui.stacked.segment.no-print
  slot
</template>

<script>
const CHILDREN_NAMES = ['filter-select', 'filter-search', 'filter-date-range']

export default {
  name: 'filters-group',
  props: {
    data: Array,
    result: null,
    watchDeep: { type: Boolean, default: true },
  },
  computed: {
    children() {
      return this.$children.filter(c => CHILDREN_NAMES.includes(c.$options.name))
    },
  },
  data() {
    return {
      enabled: false,
    }
  },
  mounted() {
    this.hook()
    this.enabled = true
    this.update()
  },
  watch: {
    data: {
      // deep: true,
      handler() {
        this.update()
      },
    },
  },
  methods: {
    hook() {
      for (const c of this.children)
        c.$on('filter', () => this.update())
    },
    update() {
      if (!this.enabled)
        return

      let filtered = this.data
      for (const c of this.children) {
        if (c && c.$filter && typeof c.$filter === 'function')
          filtered = c.$filter(filtered)
      }

      this.$emit('update:result', filtered)
    },
  },
}
</script>



// WEBPACK FOOTER //
// FiltersGroup.vue?523ef240